module.exports = __webpack_public_path__ + "img/amenities-menu.1c2c8543.svg";